import { autoinject, customElement } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { bindable } from 'aurelia-typed-observable-plugin';
import { MobileAppService } from 'services/mobile-app-service';

@autoinject
@customElement('as-page-header')
export class PageHeader {
  @bindable heading: string;
  @bindable backVisible = true;
  @bindable displayHeadingOnMobile = true;
  @bindable isMobileAppCancel = false;

  constructor(private router: Router, private mobileAppService: MobileAppService) { }

  back() {
    this.mobileAppService.isMobileApp && this.isMobileAppCancel ? this.router.navigateToRoute(this.router.currentInstruction.config.name, { mobileAppResult: 'cancel' }, { trigger: false, replace: true }) : this.router.navigateBack();
  }
}
